import React from "react";
import { Link } from "react-router-dom";

const FooterTwo = () => {
  return (
    <footer
      style={{
        backgroundColor: "#000",
        color: "#fff",
        padding: "80px 0",
        fontFamily: "Inter, sans-serif",
        fontSize: "15px",
      }}
    >
      <div
        className="container"
        style={{ maxWidth: "1320px", margin: "0 auto" }}
      >
        {/* === Logo and Description === */}
        <div style={{ textAlign: "left", marginBottom: "40px" }}>
          <img
            src="/assets/images/logo/logo-two-black.png"
            alt="Printing Dealz Logo"
            style={{ width: "30%", marginBottom: "20px" }}
          />
          <p style={{ color: "#ddd", lineHeight: "1.8" }}>
            At <strong>Printing Dealz</strong>, we make printing simple and
            reliable. From high-performance printers and premium ink cartridges
            to complete printing solutions, we deliver products trusted by
            homes, offices, and businesses alike. Experience fast delivery,
            assured quality, and expert customer care — all in one place.
          </p>
        </div>

        {/* === Trust Badges === */}
        <div
          style={{
            display: "flex",
            gap: "20px",
            marginBottom: "40px",
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              backgroundColor: "rgba(0,255,0,0.1)",
              borderRadius: "12px",
              padding: "20px 30px",
              flex: "1 1 250px",
              textAlign: "center",
            }}
          >
            <i className="ph ph-shield-check" style={{ fontSize: "28px" }}></i>
            <h4 style={{ margin: "10px 0 4px", color: "#fff" }}>
              SSL Protected
            </h4>
            <p style={{ color: "#ccc" }}>256-bit encryption</p>
          </div>

          <div
            style={{
              backgroundColor: "rgba(0,100,255,0.1)",
              borderRadius: "12px",
              padding: "20px 30px",
              flex: "1 1 250px",
              textAlign: "center",
            }}
          >
            <i className="ph ph-truck" style={{ fontSize: "28px" }}></i>
            <h4 style={{ margin: "10px 0 4px", color: "#fff" }}>
              Fast Delivery
            </h4>
            <p style={{ color: "#ccc" }}>2-day shipping</p>
          </div>

          <div
            style={{
              backgroundColor: "rgba(255,200,0,0.1)",
              borderRadius: "12px",
              padding: "20px 30px",
              flex: "1 1 250px",
              textAlign: "center",
            }}
          >
            <i className="ph ph-star" style={{ fontSize: "28px" }}></i>
            <h4 style={{ margin: "10px 0 4px", color: "#fff" }}>
              Quality Assured
            </h4>
            <p style={{ color: "#ccc" }}>Manufacturer warranty</p>
          </div>
        </div>

        {/* === Footer Columns === */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "40px",
            marginBottom: "40px",
            justifyContent: "space-between",
          }}
        >
          {/* Column 1 */}
          <div style={{ flex: "1 1 250px" }}>
            <h6 style={{ color: "#fff", marginBottom: "16px" }}>About Us</h6>
            <ul style={{ listStyle: "none", padding: 0, color: "#ddd" }}>
              <li style={{ marginBottom: "8px" }}>
                <Link
                  to="/about-us"
                  style={{ color: "#ddd", textDecoration: "none" }}
                >
                  Company Profile
                </Link>
              </li>
              <li style={{ marginBottom: "8px" }}>
                <Link
                  to="/privacy-policy"
                  style={{ color: "#ddd", textDecoration: "none" }}
                >
                  Privacy Policy
                </Link>
              </li>
              <li style={{ marginBottom: "8px" }}>
                <Link
                  to="/terms-and-conditions"
                  style={{ color: "#ddd", textDecoration: "none" }}
                >
                  Terms and Conditions
                </Link>
              </li>
              <li style={{ marginBottom: "8px" }}>
                <Link
                  to="/refund-policy"
                  style={{ color: "#ddd", textDecoration: "none" }}
                >
                  Refund Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 2 */}
          <div style={{ flex: "1 1 250px" }}>
            <h6 style={{ color: "#fff", marginBottom: "16px" }}>
              Customer Support
            </h6>
            <ul style={{ listStyle: "none", padding: 0, color: "#ddd" }}>
              <li style={{ marginBottom: "8px" }}>
                <Link
                  to="/order-track"
                  style={{ color: "#ddd", textDecoration: "none" }}
                >
                  Order Tracking
                </Link>
              </li>
              <li style={{ marginBottom: "8px" }}>
                <Link
                  to="/return-order"
                  style={{ color: "#ddd", textDecoration: "none" }}
                >
                  Return and Exchange
                </Link>
              </li>
              <li style={{ marginBottom: "8px" }}>
                <Link
                  to="/contact-us"
                  style={{ color: "#ddd", textDecoration: "none" }}
                >
                  Help Center
                </Link>
              </li>
              <li>
                <Link
                  to="/sitemap.xml"
                  style={{ color: "#ddd", textDecoration: "none" }}
                >
                  Sitemap
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3 */}
          <div style={{ flex: "1 1 250px" }}>
            <h6 style={{ color: "#fff", marginBottom: "16px" }}>
              Get in Touch
            </h6>
            <p style={{ color: "#ddd", marginBottom: "8px" }}>
              <i className="ph ph-envelope" /> info@printingdealz.com
            </p>
            <p style={{ color: "#ddd", marginBottom: "8px" }}>
              <i className="ph ph-phone" /> +1-206-466-6995
            </p>
            <p style={{ color: "#ddd" }}>
              <i className="ph ph-map-pin" /> 9200 2nd Av SW, #204A, Seattle,
              WA, 98106
            </p>
          </div>
        </div>

        {/* === Disclaimer Boxes === */}
        <div
          style={{
            backgroundColor: "rgba(255,255,255,0.1)",
            padding: "20px 30px",
            borderRadius: "10px",
            marginBottom: "20px",
          }}
        >
          <h6 style={{ color: "#ff5555", marginBottom: "8px" }}>
            <i className="ph ph-warning-circle" /> Important Legal Disclaimer
          </h6>
          <p style={{ color: "#ccc", lineHeight: "1.6" }}>
            Printing Dealz is an independent online retailer. We are not
            affiliated with, endorsed by, or sponsored by HP Inc. or any other
            printer brand. We are not an authorized dealer or official
            representative of HP Inc. All trademarks, logos, and brand names
            mentioned on this website belong to their respective owners.
            Products sold on our platform are sourced from trusted distributors
            and include manufacturer warranties. We provide independent retail
            services and customer support. HP, the HP logo, and all related
            marks are trademarks of HP Inc.
          </p>
        </div>

        <div
          style={{
            backgroundColor: "rgba(255,200,0,0.1)",
            padding: "20px 30px",
            borderRadius: "10px",
          }}
        >
          <h6 style={{ color: "#ffcc00", marginBottom: "8px" }}>
            <i className="ph ph-info" /> Important Notice
          </h6>
          <p style={{ color: "#ccc", lineHeight: "1.6" }}>
            Product availability, pricing, delivery times, and specifications
            are subject to change without notice. Please verify all current
            details before making a purchase. Warranty coverage and terms are
            provided by the respective manufacturers and may vary by product.
            Delivery times are estimated and can differ based on location,
            product stock, and shipping method. Express delivery options are
            available only in select service areas. All price matching and
            promotional discounts are subject to eligibility, verification, and
            applicable terms.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterTwo;
